exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ghost[data-v-6d430d22]{opacity:.5;background:#c8ebfb}.btn.descriptions[data-v-6d430d22]{height:38px;width:100px;color:#fff}.container-fluid[data-v-6d430d22] .mx-input{height:38px}", ""]);

// exports
